import * as $ from 'jquery';
import { DefaultService } from '../../common/services/DefaultService';
import { apiBaseUrlUser } from '../../../constants/url.constant';
import { AddressModel } from '../models/AddressModel';

export class CustomerAddressService extends DefaultService {
    private baseUrl = `${apiBaseUrlUser}/customerAddress`;

    public RouteCreate = () => `${this.baseUrl}/create`;
    public create(model: AddressModel): JQueryPromise<any> {
        return $.ajax(this.RouteCreate(), {
            type: 'post',
            data: JSON.stringify(model),
            contentType: 'application/json'
        });
    }

    public RouteEdit = () => `${this.baseUrl}/edit`;
    public edit(model: AddressModel): JQueryPromise<any> {
        return $.ajax(this.RouteEdit(), {
            type: 'put',
            data: JSON.stringify(model),
            contentType: 'application/json'
        });
    }

    public RouteDelete = (id: number) => `${this.baseUrl}/delete?id=${id}`;
    public delete(id: number): JQueryPromise<any> {
        return $.ajax(this.RouteDelete(id), {
            type: 'delete',
            data: undefined,
            contentType: 'application/json'
        });
    }

    public RouteGetList = () => `${this.baseUrl}/getList`;
    public getList(): JQueryPromise<any> {
        return $.ajax(this.RouteGetList(), {
            type: 'get',
            contentType: 'application/json'
        });
    }
}